import { useState } from "react";
import { Tooltip, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";

/**
 * Shows a scan-result path with a copy button, optionally under a shorter label.
 *
 * Note this path is NOT a value the dataset path input accepts - that field takes only
 * relative paths inside the datasets directory. Copying is for carrying the path
 * elsewhere (a terminal, a ticket, a mount command).
 */
export default function PathCell({
  path,
  label,
}: {
  path: string;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(path);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      message.error("Could not copy the path");
    }
  };

  return (
    <div className={styles.pathCell}>
      <Tooltip title={path} placement="topLeft">
        <span className={styles.pathText}>{label ?? path}</span>
      </Tooltip>
      <Tooltip title={copied ? "Copied" : "Copy path"}>
        <button
          type="button"
          className={styles.copyButton}
          onClick={handleCopy}
          aria-label="Copy path"
        >
          <CopyOutlined />
        </button>
      </Tooltip>
    </div>
  );
}
